/**
 * "2170-BISHOP", as the client writes a project.
 *
 * Projects made by early imports hold the sheet's whole label as their name -
 * "2170-BISHOP", "9513- RING STACKER" - so a name that already starts with the
 * project's number is written as it is, never "2170-2170-BISHOP".
 */
export const projectLabel = (m: { projectCode?: string | null; projectName?: string | null }): string => {
  const code = m.projectCode?.trim() ?? '';
  const name = m.projectName?.trim() ?? '';
  if (!code) return name;
  if (!name || name.toUpperCase() === code.toUpperCase()) return code;
  const number = /^[A-Za-z0-9]+/.exec(code)?.[0] ?? '';
  if (number && new RegExp(`^${number}\\s*[-–—]`, 'i').test(name)) return name;
  return `${code}-${name}`;
};
